import React from 'react';

import IntlMessages from '../helpers/IntlMessages';
import { adminRoot } from './defaultValues';

const data = [
  {
    id: 'records',
    icon: 'recordsIcon',
    label: <IntlMessages id='screens.register' />,
    sub_title: <IntlMessages id='screens.register' />,
    to: `${adminRoot}/records`,
    subs: [
      {
        icon: 'iconsminds-forward',
        label: 'screens.register.playbook',
        to: `${adminRoot}/records/playbook`,
      },
      {
        icon: 'iconsminds-forward',
        label: 'screens.register.regulation',
        to: `${adminRoot}/records/regulation`,
      },
      {
        icon: 'iconsminds-forward',
        label: 'screens.register.user',
        to: `${adminRoot}/records/user`,
      },
      {
        icon: 'iconsminds-forward',
        label: 'screens.register.sector',
        to: `${adminRoot}/records/sector`,
      },
      // Gerador antigo: rota mantida em /records/process-template, fora do menu
      // para nao confundir com os Modelos de processo.
    ],
  },
  {
    id: 'settings',
    icon: 'configurationsIcon',
    label: <IntlMessages id='screens.config' />,
    sub_title: <IntlMessages id='screens.config' />,
    to: `${adminRoot}/settings`,
    subs: [
      {
        icon: 'iconsminds-forward',
        label: 'screens.generalConfig',
        to: `${adminRoot}/records/settings`,
      },
    ],
  },
];

export default data;
